// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var DateFilter$ReactHooksTemplate = require("./dateFilter.res.js");
var ListFilter$ReactHooksTemplate = require("./listFilter.res.js");
var TextFilter$ReactHooksTemplate = require("./textFilter.res.js");
var EmailFilter$ReactHooksTemplate = require("./emailFilter.res.js");
var MsisdnFilter$ReactHooksTemplate = require("./msisdnFilter.res.js");
var NumberFilter$ReactHooksTemplate = require("./numberFilter.res.js");

function id(t) {
  return t.id;
}

function title(t) {
  return t.title;
}

function filterType(t) {
  return t.filterType;
}

function setFilterTypes(filterType, t) {
  return {
          id: t.id,
          title: t.title,
          filterType: filterType
        };
}

function toString(t) {
  var number = t.filterType;
  var tmp;
  switch (number.TAG) {
    case "Number" :
        tmp = NumberFilter$ReactHooksTemplate.toString(number._0);
        break;
    case "Date" :
        tmp = DateFilter$ReactHooksTemplate.toString(number._0);
        break;
    case "List" :
        tmp = ListFilter$ReactHooksTemplate.toString(number._0);
        break;
    case "Msisdn" :
        tmp = MsisdnFilter$ReactHooksTemplate.toString(number._0);
        break;
    case "Email" :
        tmp = EmailFilter$ReactHooksTemplate.toString(number._0);
        break;
    case "FreeText" :
        tmp = TextFilter$ReactHooksTemplate.toString(number._0);
        break;
    
  }
  return t.title + (" : " + tmp);
}

function isSelected(t) {
  var number = t.filterType;
  switch (number.TAG) {
    case "Number" :
        return NumberFilter$ReactHooksTemplate.isSelected(number._0);
    case "Date" :
        return DateFilter$ReactHooksTemplate.isSelected(number._0);
    case "List" :
        return ListFilter$ReactHooksTemplate.isSelected(number._0);
    case "Msisdn" :
        return MsisdnFilter$ReactHooksTemplate.isSelected(number._0);
    case "Email" :
        return EmailFilter$ReactHooksTemplate.isSelected(number._0);
    case "FreeText" :
        return TextFilter$ReactHooksTemplate.isSelected(number._0);
    
  }
}

function resetSelected(t) {
  var number = t.filterType;
  var filterType;
  switch (number.TAG) {
    case "Number" :
        filterType = {
          TAG: "Number",
          _0: NumberFilter$ReactHooksTemplate.resetSelected(number._0)
        };
        break;
    case "Date" :
        filterType = {
          TAG: "Date",
          _0: DateFilter$ReactHooksTemplate.resetSelected(number._0)
        };
        break;
    case "List" :
        filterType = {
          TAG: "List",
          _0: ListFilter$ReactHooksTemplate.resetSelected(number._0)
        };
        break;
    case "Msisdn" :
        filterType = {
          TAG: "Msisdn",
          _0: MsisdnFilter$ReactHooksTemplate.resetSelected(number._0)
        };
        break;
    case "Email" :
        filterType = {
          TAG: "Email",
          _0: EmailFilter$ReactHooksTemplate.resetSelected(number._0)
        };
        break;
    case "FreeText" :
        filterType = {
          TAG: "FreeText",
          _0: TextFilter$ReactHooksTemplate.resetSelected(number._0)
        };
        break;
    
  }
  return setFilterTypes(filterType, t);
}

function decodeFilterType(json) {
  var match = Json_decode.field("category_type", Json_decode.string, json);
  switch (match) {
    case "date" :
        return {
                TAG: "Date",
                _0: Json_decode.field("params", DateFilter$ReactHooksTemplate.fromJson, json)
              };
    case "email" :
        return {
                TAG: "Email",
                _0: Json_decode.field("params", EmailFilter$ReactHooksTemplate.fromJson, json)
              };
    case "list" :
        return {
                TAG: "List",
                _0: Json_decode.field("params", ListFilter$ReactHooksTemplate.fromJson, json)
              };
    case "msisdn" :
        return {
                TAG: "Msisdn",
                _0: Json_decode.field("params", MsisdnFilter$ReactHooksTemplate.fromJson, json)
              };
    default:
      return {
              TAG: "FreeText",
              _0: Json_decode.field("params", TextFilter$ReactHooksTemplate.fromJson, json)
            };
  }
}

function decodeFilterItem(json) {
  return {
          id: Json_decode.field("id", Json_decode.$$int, json),
          title: Json_decode.field("title", Json_decode.string, json),
          filterType: Json_decode.field("filter", decodeFilterType, json)
        };
}

function fromJson(json) {
  return Json_decode.field("filters", (function (param) {
                return Json_decode.list(decodeFilterItem, param);
              }), json);
}

function encodeFilter(t) {
  var numberFilter = t.filterType;
  switch (numberFilter.TAG) {
    case "Number" :
        return NumberFilter$ReactHooksTemplate.encode(numberFilter._0);
    case "Date" :
        return DateFilter$ReactHooksTemplate.encode(numberFilter._0);
    case "List" :
        return ListFilter$ReactHooksTemplate.encode(numberFilter._0);
    case "Msisdn" :
        return MsisdnFilter$ReactHooksTemplate.encode(numberFilter._0);
    case "Email" :
        return EmailFilter$ReactHooksTemplate.encode(numberFilter._0);
    case "FreeText" :
        return TextFilter$ReactHooksTemplate.encode(numberFilter._0);
    
  }
}

function encode(t) {
  return Json_encode.object_({
              hd: [
                "id",
                t.id
              ],
              tl: {
                hd: [
                  "title",
                  t.title
                ],
                tl: {
                  hd: [
                    "filter",
                    encodeFilter(t)
                  ],
                  tl: /* [] */0
                }
              }
            });
}

exports.fromJson = fromJson;
exports.title = title;
exports.filterType = filterType;
exports.id = id;
exports.setFilterTypes = setFilterTypes;
exports.toString = toString;
exports.isSelected = isSelected;
exports.resetSelected = resetSelected;
exports.encode = encode;
exports.decodeFilterItem = decodeFilterItem;
/* DateFilter-ReactHooksTemplate Not a pure module */
